import React from "react";
import { Wrapper, Title, IconContainer } from "./style";
import { MODAL_SHARE_FILE } from "store/Modals/constants";
import { useDispatch } from "react-redux";
import { closeModal } from "store/Modals/actions";
import CloseIcon from "components/commons/Icons/CloseIcon";

const Header = () => {
  const dispatch = useDispatch();

  const toggle = () => {
    dispatch(closeModal(MODAL_SHARE_FILE));
  };

  return (
    <Wrapper>
      <Title>Compartir</Title>
      <IconContainer>
        <CloseIcon onClick={toggle} />
      </IconContainer>
    </Wrapper>
  );
};

export default Header;
